import { useState } from 'react'
import { Lightbox } from './Lightbox'

/**
 * Pure display component for banner blocks.
 * Handles desktop/mobile image switching.
 * No editing UI. Safe to copy to frontend.
 * Height is controlled by .tpl-banner-wrap in template.css (400px desktop / 250px mobile),
 * unless noAspect is true, in which case the image renders at its natural aspect ratio (full width, no crop).
 * enableLightbox: 由呼叫端決定要不要點擊放大（BannerUnit 編輯器外層已自己包一層 lightbox，故不傳；
 * TransmissionView 唯讀模式直接顯示，需要自己開啟）。
 */
export function BannerView({ desktop, mobile, url, caption, noAspect = false, enableLightbox = false, onOpenLightbox }) {
  const [lightboxSrc, setLightboxSrc] = useState(null)
  const desktopUrl = desktop?.url || mobile?.url || url || ''
  const mobileUrl = mobile?.url || desktop?.url || url || ''

  if (!desktopUrl && !mobileUrl) return null

  const zoomClass = (enableLightbox || onOpenLightbox) ? 'cursor-zoom-in' : ''
  const onZoomClick = (enableLightbox || onOpenLightbox)
    ? () => onOpenLightbox ? onOpenLightbox(desktopUrl || mobileUrl) : setLightboxSrc(desktopUrl || mobileUrl)
    : undefined

  if (noAspect) {
    return (
      <>
        <div className={`tpl-banner-wrap tpl-banner-wrap--natural ${zoomClass}`} onClick={onZoomClick}>
          {desktopUrl && (
            <img
              src={desktopUrl}
              alt={caption || 'Banner'}
              className="tpl-banner-img--desktop block w-full h-auto"
              loading="lazy"
            />
          )}
          {mobileUrl && (
            <img
              src={mobileUrl}
              alt={caption || 'Banner'}
              className="tpl-banner-img--mobile block w-full h-auto"
              loading="lazy"
            />
          )}
        </div>
        {!onOpenLightbox && enableLightbox && lightboxSrc && <Lightbox src={lightboxSrc} onClose={() => setLightboxSrc(null)} />}
      </>
    )
  }

  return (
    <>
      <div className={`tpl-banner-wrap ${zoomClass}`} onClick={onZoomClick}>
        {desktopUrl && (
          <img
            src={desktopUrl}
            alt={caption || 'Banner'}
            className="tpl-banner-img--desktop absolute inset-0 w-full h-full object-cover object-center"
            loading="lazy"
          />
        )}
        {mobileUrl && (
          <img
            src={mobileUrl}
            alt={caption || 'Banner'}
            className="tpl-banner-img--mobile absolute inset-0 w-full h-full object-cover object-center"
            loading="lazy"
          />
        )}
      </div>
      {enableLightbox && lightboxSrc && <Lightbox src={lightboxSrc} onClose={() => setLightboxSrc(null)} />}
    </>
  )
}
